export default {
  svgPath: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.843 2.929l10.314 10.314V5.464h2v10.193a1 1 0 01-1 1H5.964v-2h7.778L3.43 4.343 4.843 2.93z"/>
  `,
  title: 'Arrow Down Right',
  viewBox: '0 0 21 20',
};
